module.exports = __webpack_public_path__ + "static/img/Mascot-Betask.53f7707.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mascot-Betask.png
// module id = Qgci
// module chunks = 3